(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-linear-by-component"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {

  var openModalButtons = document.querySelectorAll('.openModal');
  var bodyClass = document.getElementById("main-page-body");
  function buildInventoryBadge(data) {
    const stateClass = {
      in_stock: 'inventory-alert--in-stock',
      low_stock: 'inventory-alert--low-stock',
      backorder: 'inventory-alert--backorder',
      discontinued: 'inventory-alert--discontinued',
      default: 'inventory-alert--default'
    };

    if (!data.state || !data.message) {
      return '';
    }

    const badgeClass =
      stateClass[data.state] || 'inventory-alert--default';

    let icon = '';

    if (data.state === 'in_stock') {
      icon = `
        <svg class="inv-badge__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
          <path d="M4.5 8L6.5 10.5L11 5.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"/>
        </svg>
      `;
    } else if (
      data.state === 'low_stock' ||
      data.state === 'backorder' ||
      data.state === 'discontinued'
    ) {
      icon = `
        <svg class="inv-badge__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 2L1.5 13.5H14.5L8 2Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linejoin="round"/>
          <path d="M8 6.5V9.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"/>
          <circle cx="8" cy="11.5" r="0.75" fill="currentColor"/>
        </svg>
      `;
    }

    return `
      <div class="inv-badge ${badgeClass}">
        ${icon}
        <span class="inv-badge__text">${data.message}</span>
      </div>
    `;
  }
  openModalButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var getHandle = this.getAttribute('data-handle');
      var prodOverviews = this.closest('.list-view-item').querySelector('.prod-overviews').innerText;
      
      bodyClass.style.overflowY = "hidden";

      fetch(window.Shopify.routes.root + 'products/' + getHandle + '.js')
        .then(function(response) {
          return response.json();
        })
        .then(function(product) {
          console.log('product', product);
          document.getElementById('prod-img').src = product.featured_image;
          document.getElementById('modalTitle').innerText = product.title;
          document.getElementById('modalType').innerText = product.type;
          document.getElementById('modalDescription').innerHTML = product.description;
          document.getElementById('modalOverview').innerHTML = prodOverviews;
          document.getElementById('modalPrice').innerText = window.shopifyHelpers.formatPrice(product.price)  ;
          document.getElementById('variant_id').setAttribute('value', product.variants[0].id);
          document.getElementById('quantity').value = 1;


          const badgeWrapper = document.getElementById('modalInvBadgeWrapper');

          if (badgeWrapper) {
            badgeWrapper.innerHTML = '';

            fetch(`/products/${getHandle}?view=inventory-badge`)
              .then(res => res.json())
              .then(data => {
                if (data && data.state) {
                  badgeWrapper.innerHTML = buildInventoryBadge(data);
                }
              })
              .catch(err => {
                console.log('Inventory badge failed', err);
              });
          }
          // Update shipping estimate in modal
          if (window.shippingEstimateCore && window.settings?.shipping_estimates_enabled) {
            updateModalShippingEstimate(product, 1);
          }

          var productSku = '';
            if (product.variants[0].sku && product.variants[0].sku.trim() !== '') {
              productSku = product.variants[0].sku;
              // console.log('Using variant SKU:', productSku);
            } else if (product.sku && product.sku.trim() !== '') {
              productSku = product.sku;
              // console.log('Using SKU:', productSku);
            } else {
              console.log('No SKU found');
            }

            // ✅ Modal SKU field update کریں:
            var modalSkuInput = document.getElementById('modal-sku-field');
            if (modalSkuInput) {
              modalSkuInput.value = productSku;
              // console.log('✅ SKU set to:', modalSkuInput.value);
            } else {
              console.error('❌ SKU input field not found!');
            }
          document.querySelectorAll('#myModal .quantity__button.disabled').forEach(function(button) {
            button.classList.remove('disabled');
          });
          document.querySelector('.message').innerHTML = '';
          if(product.variants[0].quantity_rule){
            document.getElementById('quantity').setAttribute('min', product.variants[0].quantity_rule.min);
            document.getElementById('quantity').setAttribute('max', product.variants[0].quantity_rule.max);
            document.getElementById('quantity').setAttribute('step', product.variants[0].quantity_rule.increment);
          }
          else {
            document.getElementById('quantity').setAttribute('min', 1);
            document.getElementById('quantity').setAttribute('step', 1);
            document.getElementById('quantity').removeAttribute('max');
          }
          
          // Listen for quantity changes in modal
          var quantityInput = document.getElementById('quantity');
          if (quantityInput) {
            quantityInput.addEventListener('change', function() {
              var qty = parseInt(this.value) || 1;
              if (window.shippingEstimateCore && window.settings?.shipping_estimates_enabled) {
                updateModalShippingEstimate(product, qty);
              }
            });
            quantityInput.addEventListener('input', function() {
              var qty = parseInt(this.value) || 1;
              if (window.shippingEstimateCore && window.settings?.shipping_estimates_enabled) {
                updateModalShippingEstimate(product, qty);
              }
            });
          }
          fetch(window.Shopify.routes.root + 'products/' + getHandle + '?_no_cache=true')
            .then(function(response) {
              // Check karein ki response HTML hai ya nahi
              const contentType = response.headers.get("content-type");
              if (contentType && contentType.indexOf("application/json") !== -1) {
                console.warn("Abhi bhi JSON mil raha hai, hum HTML expect kar rahe the.");
              }
              return response.text(); 
            })
            .then(function(productText) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(productText, 'text/html');
              console.log("doc>>",doc);
              
              // Debugging ke liye check karein ki doc mein element mila ya nahi
              var newFormContent = doc.querySelector('.product__info-container');
              var targetForm = document.querySelector('.popup-flex-elements');
              var targetDisable = document.querySelector('.disableCTA');
              console.log("newFormContent>>",newFormContent,"targetForm>>",targetForm,"targetDisable>>",targetDisable);
              if (newFormContent && targetForm) {
                var disableCTA = newFormContent.getAttribute('data-disable-cta');
                var disableCTAText = newFormContent.getAttribute('data-disable-text');
                targetDisable.querySelector('button span').innerText = disableCTAText;
                targetForm.classList.add('hidden');
                targetDisable.style.display == 'none';
                if(disableCTA == "true"){
                  console.log("yha",disableCTA)
                  targetForm.classList.add('hidden');
                  targetDisable.style.display == 'block';
                }
                else{
                  console.log("na yha ",disableCTA)
                  targetDisable.style.display == 'none';
                  targetForm.classList.remove('hidden');
                }

                console.log('✅ Form Content successfully updated from HTML response');
              } else {
                console.error('❌ Element "sales-tools-form" nahi mila');
              }
            })
            .catch(function(error) {
              console.error('Error fetching product HTML:', error);
            });
        })
        .catch(function(error) {
          console.error('Error fetching product:', error);
        });
    });
  });
    
  var modal = document.getElementById("myModal");
  var buttons = document.querySelectorAll(".openModal");
  var span = document.getElementsByClassName("close")[0];



  buttons.forEach(function(button) {
      button.onclick = function() {
        setTimeout(function() {
            modal.style.display = "block";
        }, 500);
      }
  });
    
  span.onclick = function() {
    modal.style.display = "none";
    bodyClass.style.overflowY = "auto";
  }

  // When the user clicks anywhere outside of the modal, close it
  // window.onclick = function(event) {
  //   if (event.target == modal) {
  //     modal.style.display = "none";
  //   }
  // }
});

// Add load More
document.addEventListener('DOMContentLoaded', function() {
  let itemsToShow = 8;
  const listItems = document.querySelectorAll('.list-view-item');
  const loadMoreButton = document.getElementById('loadMore');

  loadMoreButton?.addEventListener('click', function() {
    const hiddenItems = Array.from(listItems).filter(item => item.style.display === 'none');
    for (let i = 0; i < itemsToShow; i++) {
      if (hiddenItems[i]) {
        hiddenItems[i].style.display = 'flex';
      }
    }
    if (hiddenItems.length <= itemsToShow) {
      loadMoreButton.style.display = 'none';
    }
  });
  });

  // Function to update shipping estimate in modal
  async function updateModalShippingEstimate(product, quantity) {
    if (!window.shippingEstimateCore || !window.settings?.shipping_estimates_enabled) {
      return;
    }

    var modalEstimate = document.getElementById('modalShippingEstimate');
    if (!modalEstimate) return;

    try {
      var message = await window.shippingEstimateCore.getShippingEstimateForProduct(
        product.id,
        quantity,
        'pdp',
        product.handle
      );

      var messageElement = modalEstimate.querySelector('.product__shipping-message');
      if (messageElement && message && message.trim() !== '') {
        // Get shipping icon from hidden element or use fallback
        const shippingIconElement = document.getElementById('shipping-icon-svg');
        const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
        messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
        modalEstimate.style.display = 'block';
      } else {
        modalEstimate.style.display = 'none';
      }
    } catch (error) {
      modalEstimate.style.display = 'none';
    }
  }

  // Update shipping estimates for list view products
  function updateLinearComponentShippingEstimates() {
    // Check if shipping estimates are enabled
    var shippingEnabled = false;
    if (window.settings && window.settings.shipping_estimates_enabled) {
      shippingEnabled = true;
    } else if (typeof window.theme !== 'undefined' && window.theme.settings && window.theme.settings.shipping_estimates_enabled) {
      shippingEnabled = true;
    }
    
    if (!shippingEnabled) {
      return;
    }
    
    if (!window.shippingEstimateCore) {
      // Retry if core not loaded yet (max 10 retries = 2 seconds)
      if (typeof updateLinearComponentShippingEstimates.retryCount === 'undefined') {
        updateLinearComponentShippingEstimates.retryCount = 0;
      }
      if (updateLinearComponentShippingEstimates.retryCount < 10) {
        updateLinearComponentShippingEstimates.retryCount++;
        setTimeout(updateLinearComponentShippingEstimates, 200);
      }
      return;
    }
    
    // Reset retry count on success
    updateLinearComponentShippingEstimates.retryCount = 0;

    // Find all estimate containers except the modal one
    var estimateContainers = document.querySelectorAll('.linear-component-shipping-estimate');
    var modalEstimate = document.getElementById('modalShippingEstimate');
    
    if (estimateContainers.length === 0) {
      return;
    }
    
    estimateContainers.forEach(function(container) {
      // Skip modal estimate
      if (modalEstimate && container === modalEstimate) {
        return;
      }
      
      var productId = container.getAttribute('data-product-id');
      var productHandle = container.getAttribute('data-product-handle');
      
      if (!productId) {
        return;
      }
      
      var listItem = container.closest('.list-view-item');
      var quantityInput = listItem ? listItem.querySelector('.quantity__input, input[name="quantity"]') : null;
      var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      // Use data-quantity attribute as fallback
      if (!quantityInput) {
        var dataQuantity = container.getAttribute('data-quantity');
        if (dataQuantity) {
          quantity = parseInt(dataQuantity) || 1;
        }
      }
      
      var messageElement = container.querySelector('.product__shipping-message');
      if (!messageElement) {
        // Create message element if it doesn't exist
        messageElement = document.createElement('p');
        messageElement.className = 'product__shipping-message caption';
        container.appendChild(messageElement);
      }

      // Always show container initially
      container.style.display = 'block';

      window.shippingEstimateCore.getShippingEstimateForProduct(
        productId,
        quantity,
        'pdp',
        productHandle
      ).then(function(message) {
        if (messageElement) {
          if (message && message.trim() !== '') {
            // Get shipping icon from hidden element or use fallback
            const shippingIconElement = document.getElementById('shipping-icon-svg');
            const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
            messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
            container.style.display = 'block';
          } else {
            // Keep existing message if update fails
            if (messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          }
        }
      }).catch(function(error) {
        // Keep existing message from snippet if update fails
        if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
          container.style.display = 'none';
        }
      });
    });
  }

  // Initialize shipping estimates when page loads
  function initLinearComponentShippingEstimates() {
    // Wait for both DOM and scripts to be ready
    function tryInit() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(updateLinearComponentShippingEstimates, 1000);
        });
      } else {
        setTimeout(updateLinearComponentShippingEstimates, 1000);
      }
    }
    
    tryInit();
  }

  initLinearComponentShippingEstimates();

  // Update estimates when quantity changes in list view
  document.addEventListener('change', function(e) {
    if (e.target.matches('.list-view-item .quantity__input, .list-view-item input[name="quantity"]')) {
      var listItem = e.target.closest('.list-view-item');
      if (listItem && window.shippingEstimateCore) {
        var container = listItem.querySelector('.linear-component-shipping-estimate');
        if (container) {
          var productId = container.getAttribute('data-product-id');
          var productHandle = container.getAttribute('data-product-handle');
          var quantity = parseInt(e.target.value) || 1;
          
          var messageElement = container.querySelector('.product__shipping-message');
          if (!messageElement) {
            messageElement = document.createElement('p');
            messageElement.className = 'product__shipping-message caption';
            container.appendChild(messageElement);
          }
          
          window.shippingEstimateCore.getShippingEstimateForProduct(
            productId,
            quantity,
            'pdp',
            productHandle
          ).then(function(message) {
            if (messageElement && message && message.trim() !== '') {
              // Get shipping icon from hidden element or use fallback
              const shippingIconElement = document.getElementById('shipping-icon-svg');
              const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
              messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
              container.style.display = 'block';
            } else if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          }).catch(function() {
            if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          });
        }
      }
    }
  });

  // Also listen for input events for real-time updates
  document.addEventListener('input', function(e) {
    if (e.target.matches('.list-view-item .quantity__input, .list-view-item input[name="quantity"]')) {
      var listItem = e.target.closest('.list-view-item');
      if (listItem && window.shippingEstimateCore) {
        var container = listItem.querySelector('.linear-component-shipping-estimate');
        if (container) {
          var productId = container.getAttribute('data-product-id');
          var productHandle = container.getAttribute('data-product-handle');
          var quantity = parseInt(e.target.value) || 1;
          
          var messageElement = container.querySelector('.product__shipping-message');
          if (!messageElement) {
            messageElement = document.createElement('p');
            messageElement.className = 'product__shipping-message caption';
            container.appendChild(messageElement);
          }
          
          window.shippingEstimateCore.getShippingEstimateForProduct(
            productId,
            quantity,
            'pdp',
            productHandle
          ).then(function(message) {
            if (messageElement && message && message.trim() !== '') {
              // Get shipping icon from hidden element or use fallback
              const shippingIconElement = document.getElementById('shipping-icon-svg');
              const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
              messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
              container.style.display = 'block';
            } else if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          }).catch(function() {
            if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          });
        }
      }
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-sales-tool-page"]) return;
  try {
    

  function toggleNotifyMeAndForm(notifyMe, product) {
    var salesToolsForm = document.querySelector('#myModal sales-tools-form');
    var notifyMeBtn = document.getElementById('notify-me-btn-popup');
    if (notifyMe === 'true' || notifyMe === true) {
      if (salesToolsForm) {
        salesToolsForm.style.display = 'none';
      }
      if (notifyMeBtn) {
        notifyMeBtn.style.display = 'block';
      }
    } else {
      if (salesToolsForm) {
        salesToolsForm.style.display = '';
      }
      if (notifyMeBtn) {
        notifyMeBtn.style.display = 'none';
      }
    }

    // Update data-product-id and data-variant-id attributes in the button inside notify-me-btn-popup
    var notifyMeBtnPopup = document.getElementById('notify-me-btn-popup');
    if (notifyMeBtnPopup) {
      var presaleButton = notifyMeBtnPopup.querySelector('[data-presale]');
      if (presaleButton && product && product.id && product.variants && product.variants.length > 0) {
        presaleButton.setAttribute('data-product-id', product.id);
        presaleButton.setAttribute('data-variant-id', product.variants[0].id);
      }
    }

    // Bind click handler to the presale button inside notify-me-btn-popup
    var notifyMeBtnPopup = document.getElementById('notify-me-btn-popup');
    if (notifyMeBtnPopup) {
      var presaleButton = notifyMeBtnPopup.querySelector('[data-presale-button]');
      if (presaleButton) {
        presaleButton.addEventListener('click', function() {
          if (typeof window._RestockRocket !== 'undefined' && product && product.id && product.variants && product.variants.length > 0) {
            var productData = {
              id: product.id,
              title: product.title || '',
              type: product.type || '',
              featured_image: product.featured_image || '',
              variants: [
                {
                  id: product.variants[0].id,
                  available: product.variants[0].available
                }
              ]
            };
            if(window._RestockRocket){
              window._RestockRocket.openModal(productData, product.variants[0].id);
            }
          }
        });
      }
    }
  
  }

  function togglePreorderAndForm(preorder, product){
    const salesToolsForm = document.querySelector('#myModal sales-tools-form');
    const projectSearch = document.querySelector('#project-search-modal-now');
    const addToCartCta = document.querySelector('.modal-content .prod-info button.add_to_cart.button.primary');
    const customBox = document.querySelector('custom-box');

    if(preorder == 'true' || preorder == true){
      if (projectSearch) {
        projectSearch.style.display = 'none';
      }
      if (salesToolsForm) {
        salesToolsForm.setAttribute('data-preorder', 'true');
      }
      if (addToCartCta) {
        addToCartCta.innerHTML = 'Preorder';
      }
      if (customBox) {
        customBox.style.marginBottom = '10px';
      }
    }
    else {
      if (projectSearch) {
        projectSearch.style.display = 'block';
      }
      if (salesToolsForm) {
        salesToolsForm.removeAttribute('data-preorder');
      }
      if (addToCartCta) {
        addToCartCta.innerHTML = 'Add to Cart';
      }
      if (customBox) {
        customBox.style.marginBottom = '0px';
      }
    }
    
  }

  document.addEventListener('DOMContentLoaded', function() {

    var openModalButtons = document.querySelectorAll('.openModal');
    var bodyClass = document.getElementById("main-page-body");

    openModalButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var getHandle = this.getAttribute('data-handle');
        var notifyMe = this.getAttribute('data-notify-me');
        var preorder = this.getAttribute('data-preorder');
        var prodOverviews = this.closest('.list-view-item').querySelector('.prod-overviews').innerText;

        bodyClass.style.overflowY = "hidden";

        function buildInventoryBadge(data) {
          const stateClass = {
            in_stock: 'inventory-alert--in-stock',
            low_stock: 'inventory-alert--low-stock',
            backorder: 'inventory-alert--backorder',
            discontinued: 'inventory-alert--discontinued',
            default: 'inventory-alert--default'
          };

          if (!data.state || !data.message) {
            return '';
          }

          const badgeClass =
            stateClass[data.state] || 'inventory-alert--default';

          let icon = '';

          if (data.state === 'in_stock') {
            icon = `
              <svg class="inv-badge__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                <path d="M4.5 8L6.5 10.5L11 5.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>
            `;
          } else if (
            data.state === 'low_stock' ||
            data.state === 'backorder' ||
            data.state === 'discontinued'
          ) {
            icon = `
              <svg class="inv-badge__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2L1.5 13.5H14.5L8 2Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linejoin="round"/>
                <path d="M8 6.5V9.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"/>
                <circle cx="8" cy="11.5" r="0.75" fill="currentColor"/>
              </svg>
            `;
          }

          return `
            <div class="inv-badge ${badgeClass}">
              ${icon}
              <span class="inv-badge__text">${data.message}</span>
            </div>
          `;
        }

        fetch(window.Shopify.routes.root + 'products/' + getHandle + '.js')
          .then(function(response) {
            return response.json();
          })
          .then(function(product) {
            
            document.getElementById('prod-img').src = product.featured_image;
            document.getElementById('modalTitle').innerText = product.title;
            document.getElementById('modalSku').querySelector('span').innerText =  product?.variants[0]?.sku;
            document.getElementById('modalType').innerText = product.type;
            document.getElementById('modalDescription').innerHTML = product.description;
            document.getElementById('modalOverview').innerHTML = prodOverviews;
            document.getElementById('modalPrice').innerText = window.shopifyHelpers.formatPrice(product.price)  ;
            document.getElementById('variant_id').setAttribute('value', product.variants[0].id);
            document.getElementById('quantity').value = 1;


          const badgeWrapper = document.getElementById('modalInvBadgeWrapper');

          if (badgeWrapper) {
            badgeWrapper.innerHTML = '';

            fetch(`/products/${getHandle}?view=inventory-badge`)
              .then(res => res.json())
              .then(data => {
                if (data && data.state) {
                  badgeWrapper.innerHTML = buildInventoryBadge(data);
                }
              })
              .catch(err => {
                console.log('Inventory badge failed', err);
              });
          }

            // Update shipping estimate in modal
            if (window.shippingEstimateCore && window.settings?.shipping_estimates_enabled) {
              updateModalShippingEstimate(product, 1);
            }

            var productSku = '';
            if (product.variants[0].sku && product.variants[0].sku.trim() !== '') {
              productSku = product.variants[0].sku;
              console.log('Using variant SKU:', productSku);
            } else if (product.sku && product.sku.trim() !== '') {
              productSku = product.sku;
              // console.log('Using SKU:', productSku);
            } else {
              console.log('No SKU found');
            }

            var modalSkuInput = document.getElementById('modal-sku-field');
            if (modalSkuInput) {
              modalSkuInput.value = productSku;
              console.log('✅ SKU set to:', modalSkuInput.value);
            } else {
              console.error('❌ SKU input field not found!');
            }
            document.querySelectorAll('#myModal .quantity__button.disabled').forEach(function(button) {
              button.classList.remove('disabled');
            });
            document.querySelector('.message').innerHTML = '';

            if (product.variants[0].quantity_rule){
              document.getElementById('quantity').setAttribute('min', product.variants[0].quantity_rule.min);
              document.getElementById('quantity').setAttribute('max', product.variants[0].quantity_rule.max);
              document.getElementById('quantity').setAttribute('step', product.variants[0].quantity_rule.increment);
            }
            else {
              document.getElementById('quantity').setAttribute('min', 1);
              document.getElementById('quantity').setAttribute('step', 1);
              document.getElementById('quantity').removeAttribute('max');
            }

            toggleNotifyMeAndForm(notifyMe, product );
            togglePreorderAndForm(preorder, product );

            // Listen for quantity changes in modal
            var quantityInput = document.getElementById('quantity');
            if (quantityInput) {
              quantityInput.addEventListener('change', function() {
                var qty = parseInt(this.value) || 1;
                if (window.shippingEstimateCore && window.settings?.shipping_estimates_enabled) {
                  updateModalShippingEstimate(product, qty);
                }
              });
              quantityInput.addEventListener('input', function() {
                var qty = parseInt(this.value) || 1;
                if (window.shippingEstimateCore && window.settings?.shipping_estimates_enabled) {
                  updateModalShippingEstimate(product, qty);
                }
              });
            }
              fetch(window.Shopify.routes.root + 'products/' + getHandle + '?_no_cache=true')
                .then(function(response) {
                  // Check karein ki response HTML hai ya nahi
                  const contentType = response.headers.get("content-type");
                  if (contentType && contentType.indexOf("application/json") !== -1) {
                    console.warn("Abhi bhi JSON mil raha hai, hum HTML expect kar rahe the.");
                  }
                  return response.text(); 
                })
                .then(function(productText) {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(productText, 'text/html');
                  console.log("doc>>",doc);
                  
                  // Debugging ke liye check karein ki doc mein element mila ya nahi
                  var newFormContent = doc.querySelector('.product__info-container');
                  var targetForm = document.querySelector('.popup-flex-elements');
                  var targetDisable = document.querySelector('.disableCTA');
                  console.log("newFormContent>>",newFormContent,"targetForm>>",targetForm,"targetDisable>>",targetDisable);
                  if (newFormContent && targetForm) {
                    var disableCTA = newFormContent.getAttribute('data-disable-cta');
                    var disableCTAText = newFormContent.getAttribute('data-disable-text');
                    targetDisable.querySelector('button span').innerText = disableCTAText;
                    targetForm.classList.add('hidden');
                    targetDisable.style.display == 'none';
                    if(disableCTA == "true"){
                      console.log("yha",disableCTA)
                      targetForm.classList.add('hidden');
                      targetDisable.style.display == 'block';
                    }
                    else{
                      console.log("na yha ",disableCTA)
                      targetDisable.style.display == 'none';
                      targetForm.classList.remove('hidden');
                    }

                    console.log('✅ Form Content successfully updated from HTML response');
                  } else {
                    console.error('❌ Element "sales-tools-form" nahi mila');
                  }
                })
                .catch(function(error) {
                  console.error('Error fetching product HTML:', error);
                });

            modal.style.display = "block";

          })
          .catch(function(error) {
            console.error('Error fetching product:', error);
          });
      });
    });

    var modal = document.getElementById("myModal");
    var buttons = document.querySelectorAll(".openModal");
    var span = document.getElementsByClassName("close")[0];

    // buttons.forEach(function(button) {
    //   button.onclick = function() {
    //     setTimeout(function() {
    //       modal.style.display = "block";
    //     }, 500);
    //   }
    // });

    span.onclick = function() {
      modal.style.display = "none";
      bodyClass.style.overflowY = "auto";
    }

    // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function(event) {
    //   if (event.target == modal) {
    //     modal.style.display = "none";
    //   }
    // }
  });

  // Add load More
  document.addEventListener('DOMContentLoaded', function() {
    let itemsToShow = 8;
    const listItems = document.querySelectorAll('.list-view-item');
    const loadMoreButton = document.getElementById('loadMore');

    loadMoreButton?.addEventListener('click', function() {
      const hiddenItems = Array.from(listItems).filter((item) => item.style.display === 'none');
      for (let i = 0; i < itemsToShow; i++) {
        if (hiddenItems[i]) {
          hiddenItems[i].style.display = 'flex';
        }
      }
      if (hiddenItems.length <= itemsToShow) {
        loadMoreButton.style.display = 'none';
      }
    });
  });

  // Function to update shipping estimate in modal
  async function updateModalShippingEstimate(product, quantity) {
    if (!window.shippingEstimateCore || !window.settings?.shipping_estimates_enabled) {
      return;
    }

    var modalEstimate = document.getElementById('modalShippingEstimate');
    if (!modalEstimate) return;

    try {
      var message = await window.shippingEstimateCore.getShippingEstimateForProduct(
        product.id,
        quantity,
        'pdp',
        product.handle
      );

      var messageElement = modalEstimate.querySelector('.product__shipping-message');
      if (messageElement && message && message.trim() !== '') {
        // Get shipping icon from hidden element or use fallback
        const shippingIconElement = document.getElementById('shipping-icon-svg');
        const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
        messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
        modalEstimate.style.display = 'block';
      } else {
        modalEstimate.style.display = 'none';
      }
    } catch (error) {
      modalEstimate.style.display = 'none';
    }
  }

  // Update shipping estimates for list view products
  function updateSalesToolShippingEstimates() {
    // Check if shipping estimates are enabled
    var shippingEnabled = false;
    if (window.settings && window.settings.shipping_estimates_enabled) {
      shippingEnabled = true;
    } else if (typeof window.theme !== 'undefined' && window.theme.settings && window.theme.settings.shipping_estimates_enabled) {
      shippingEnabled = true;
    }
    
    if (!shippingEnabled) {
      return;
    }
    
    if (!window.shippingEstimateCore) {
      // Retry if core not loaded yet (max 10 retries = 2 seconds)
      if (typeof updateSalesToolShippingEstimates.retryCount === 'undefined') {
        updateSalesToolShippingEstimates.retryCount = 0;
      }
      if (updateSalesToolShippingEstimates.retryCount < 10) {
        updateSalesToolShippingEstimates.retryCount++;
        setTimeout(updateSalesToolShippingEstimates, 200);
      }
      return;
    }
    
    // Reset retry count on success
    updateSalesToolShippingEstimates.retryCount = 0;

    // Find all estimate containers except the modal one
    var estimateContainers = document.querySelectorAll('.linear-component-shipping-estimate');
    var modalEstimate = document.getElementById('modalShippingEstimate');
    
    if (estimateContainers.length === 0) {
      return;
    }
    
    estimateContainers.forEach(function(container) {
      // Skip modal estimate
      if (modalEstimate && container === modalEstimate) {
        return;
      }
      
      var productId = container.getAttribute('data-product-id');
      var productHandle = container.getAttribute('data-product-handle');
      
      if (!productId) {
        return;
      }
      
      var listItem = container.closest('.list-view-item');
      var quantityInput = listItem ? listItem.querySelector('.quantity__input, input[name="quantity"]') : null;
      var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      // Use data-quantity attribute as fallback
      if (!quantityInput) {
        var dataQuantity = container.getAttribute('data-quantity');
        if (dataQuantity) {
          quantity = parseInt(dataQuantity) || 1;
        }
      }
      
      var messageElement = container.querySelector('.product__shipping-message');
      if (!messageElement) {
        // Create message element if it doesn't exist
        messageElement = document.createElement('p');
        messageElement.className = 'product__shipping-message caption';
        container.appendChild(messageElement);
      }

      // Always show container initially
      container.style.display = 'block';

      window.shippingEstimateCore.getShippingEstimateForProduct(
        productId,
        quantity,
        'pdp',
        productHandle
      ).then(function(message) {
        if (messageElement) {
          if (message && message.trim() !== '') {
            // Get shipping icon from hidden element or use fallback
            const shippingIconElement = document.getElementById('shipping-icon-svg');
            const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
            messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
            container.style.display = 'block';
          } else {
            // Keep existing message if update fails
            if (messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          }
        }
      }).catch(function(error) {
        // Keep existing message from snippet if update fails
        if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
          container.style.display = 'none';
        }
      });
    });
  }

  // Initialize shipping estimates when page loads
  function initSalesToolShippingEstimates() {
    // Wait for both DOM and scripts to be ready
    function tryInit() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(updateSalesToolShippingEstimates, 1000);
        });
      } else {
        setTimeout(updateSalesToolShippingEstimates, 1000);
      }
    }
    
    tryInit();
  }

  initSalesToolShippingEstimates();

  // Update estimates when quantity changes in list view
  document.addEventListener('change', function(e) {
    if (e.target.matches('.list-view-item .quantity__input, .list-view-item input[name="quantity"]')) {
      var listItem = e.target.closest('.list-view-item');
      if (listItem && window.shippingEstimateCore) {
        var container = listItem.querySelector('.linear-component-shipping-estimate');
        if (container) {
          var productId = container.getAttribute('data-product-id');
          var productHandle = container.getAttribute('data-product-handle');
          var quantity = parseInt(e.target.value) || 1;
          
          var messageElement = container.querySelector('.product__shipping-message');
          if (!messageElement) {
            messageElement = document.createElement('p');
            messageElement.className = 'product__shipping-message caption';
            container.appendChild(messageElement);
          }
          
          window.shippingEstimateCore.getShippingEstimateForProduct(
            productId,
            quantity,
            'pdp',
            productHandle
          ).then(function(message) {
            if (messageElement && message && message.trim() !== '') {
              // Get shipping icon from hidden element or use fallback
              const shippingIconElement = document.getElementById('shipping-icon-svg');
              const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
              messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
              container.style.display = 'block';
            } else if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          }).catch(function() {
            if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          });
        }
      }
    }
  });

  // Also listen for input events for real-time updates
  document.addEventListener('input', function(e) {
    if (e.target.matches('.list-view-item .quantity__input, .list-view-item input[name="quantity"]')) {
      var listItem = e.target.closest('.list-view-item');
      if (listItem && window.shippingEstimateCore) {
        var container = listItem.querySelector('.linear-component-shipping-estimate');
        if (container) {
          var productId = container.getAttribute('data-product-id');
          var productHandle = container.getAttribute('data-product-handle');
          var quantity = parseInt(e.target.value) || 1;
          
          var messageElement = container.querySelector('.product__shipping-message');
          if (!messageElement) {
            messageElement = document.createElement('p');
            messageElement.className = 'product__shipping-message caption';
            container.appendChild(messageElement);
          }
          
          window.shippingEstimateCore.getShippingEstimateForProduct(
            productId,
            quantity,
            'pdp',
            productHandle
          ).then(function(message) {
            if (messageElement && message && message.trim() !== '') {
              // Get shipping icon from hidden element or use fallback
              const shippingIconElement = document.getElementById('shipping-icon-svg');
              const shippingIcon = shippingIconElement ? shippingIconElement.innerHTML.trim() : '';
              messageElement.innerHTML = shippingIcon + '<span>' + message + '</span>';
              container.style.display = 'block';
            } else if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          }).catch(function() {
            if (messageElement && messageElement.textContent.trim() === '' && !messageElement.querySelector('svg')) {
              container.style.display = 'none';
            }
          });
        }
      }
    }
  });


  } catch(e) { console.error(e); }
})();
})();
